var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128,
    height: 128,
    className: "icon",
    viewBox: "0 0 1024 1024",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      @font-face{font-family:feedback-iconfont;src:url(//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944)format(\"woff2\"),url(//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944)format(\"woff\"),url(//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944)format(\"truetype\")}\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M401.024 836.31a36.267 36.267 0 1 0 51.285-51.286L215.552 548.267h637.781a36.267 36.267 0 1 0 0-72.534H215.552l236.8-236.757a36.267 36.267 0 0 0-51.328-51.285L102.357 486.357a36.267 36.267 0 0 0 0 51.286l298.667 298.666z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeft);
export default ForwardRef;